import { graphql } from 'gql';

export const uerActKC3TotalsGql = graphql(`
    query uerActKC3Totals($actKC3Id: Long!) {
        uerActKC3Totals(actKC3Id: $actKC3Id) {
            data {
                name
                isHeadLine
                startWorkCost
                startYearCost
                reportingPeriodCost
                isOtherCost
                totalType
            }
        }
    }
`);
